import React, { useCallback, useState } from 'react';
import * as Styles from './DeleteSiteModal.styles';
import { Button, Modal, TextField } from 'gatorcomponents';

const DeleteSiteModal = ({
  onClose,
  onDeleteSite,
  isLegacy = false,
  content = {
    modalLegacy: {
      title: 'This site was made in an older version and needs to be deleted through the Client Portal.',
      description: 'To delete: Access the Client Portal › Hosting and Servers › Manage › Site Builder Management › Delete Site or follow the instructions in the article: ',
      articleLink: 'How to delete my site',
      articleUrl: 'https://support.hostgator.com/hc/en-us/articles/360060828592-How-to-delete-my-site-created-with-Site-Builder-',
      confirmButtonLabel: 'Ok, got it',
    },
    modal: {
      title: 'Are you sure you want to delete this site?',
      description: 'This action deletes everything (files, images, databases...) from your site and cannot be undone.',
      inputMatchWord: 'delete',
      inputLabel: 'Type <b>delete</b> below to confirm.',
      inputPlaceholder: 'Type the word delete',
      cancelButtonLabel: 'Cancel',
      confirmButtonLabel: 'Delete my site',
      wrongKeyword: 'Incorrect keyword, please try again.',
    },
  },
  testId = 'delete-site-modal',
  isLoading = false,
}) => {
  const [inputValue, setInputValue] = useState('');
  const handleOnClose = useCallback(() => {
    onClose && onClose();
  }, [onClose]);

  const handleOnDeleteSite = useCallback(() => {
    if (onDeleteSite) {
      onDeleteSite();
    }
  }, [onDeleteSite]);

  return (
    <Modal onClose={handleOnClose} testId={testId}>
      {!isLegacy && (
        <>
          <Styles.Wrapper>
            <Styles.Title>{content.modal.title}</Styles.Title>
            <Styles.Description>
              {content.modal.description}
            </Styles.Description>
            <Styles.Description dangerouslySetInnerHTML={{ __html: content.modal.inputLabel }} />
            <Styles.InputAdapter>
              <TextField
                label={content.modal.inputPlaceholder}
                onChange={e => setInputValue(e.target.value)}
                value={inputValue}
                testId="delete-site-input"
              />
            </Styles.InputAdapter>
          </Styles.Wrapper>

          <Styles.ButtonContainer>
            <Button
              label={content.modal.cancelButtonLabel}
              onClick={handleOnClose}
              testId="cancel-button"
              variant="secondary"
              size="large"
            />
            <Button
              label={content.modal.confirmButtonLabel}
              onClick={handleOnDeleteSite}
              testId="delete-button"
              variant="primary"
              disabled={inputValue.toLowerCase() !== content.modal.inputMatchWord || isLoading}
              loading={isLoading}
              size="large"
            />
          </Styles.ButtonContainer>
        </>
      )}
      {isLegacy && (
        <>
          <Styles.Wrapper>
            <Styles.Title>{content.modalLegacy.title}</Styles.Title>
            <Styles.Description dangerouslySetInnerHTML={{ __html: content.modalLegacy.description }} />
          </Styles.Wrapper>

          <Styles.ButtonContainer>
            <Button
              label={content.modalLegacy.confirmButtonLabel}
              onClick={handleOnClose}
              testId="legacy-ok-button"
              variant="primary"
              size="large"
            />
          </Styles.ButtonContainer>
        </>
      )}
    </Modal>
  );
};

export default DeleteSiteModal;
